import React from 'react';
import PropTypes from 'prop-types';
import {
  noop, filter,
} from 'lodash';
import {
  FINANCE_BANK_JOURNAL_FORM_FIELDS,
} from '../../../../../constants/finance/finance.constant';
import ListForm from '../../../../../components/ListForm/ListForm.component';

export default function BankJournalFormHeader(props) {
  const {
    form, coa, onFormChange, isDebit, onSearchUnit,
    onSearchBankAccount, isReconciliation,
    onSearchDestinationAccount, user,
  } = props;
  const { value } = form;
  const { tipe = 0 } = value;
  let fields = { ...FINANCE_BANK_JOURNAL_FORM_FIELDS };
  const journalType = filter(fields, o => o.name === 'type');
  const formType = filter(fields, o => o.name === 'tipe');
  const rekeningSelector = filter(fields, o => o.name === 'bank_account');
  const destinationSelector = filter(fields, o => o.name === 'destination_account');
  const fundType = filter(fields, o => o.name === 'fund_type');

  const dateSelector = filter(fields, o => o.name === 'date');
  const unitSelector = filter(fields, o => o.name === 'unit');

  dateSelector[0].disabled = true;

  if (!isReconciliation) {
    if (!isDebit) {
      formType[0].data = [
        { label: 'Standard', value: '1' },
      ];

      fundType[0].data = [
        { label: 'Anggaran', value: 'BUDGET' },
      ];
    } else {
      formType[0].data = [
        { label: 'Standard', value: '1' },
        { label: 'Rekonsiliasi', value: '2' },
      ];
      fundType[0].data = [
        { label: 'Anggaran', value: 'BUDGET' },
        { label: 'Non Anggaran', value: 'NON_BUDGET' },
      ];
    }
    journalType[0].disabled = false;
    formType[0].disabled = false;
    fundType[0].disabled = false;
    unitSelector[0].disabled = false;

    if (user.prm_school_units_id && user.prm_school_units_id === 95) {
      dateSelector[0].disabled = false;
    } else {
      dateSelector[0].disabled = true;
    }
  } else {
    journalType[0].disabled = true;
    formType[0].disabled = true;
    dateSelector[0].disabled = true;
    formType[0].data = [
      { label: 'Rekonsiliasi', value: '2' },
    ];
    fundType[0].data = [
      { label: 'Anggaran', value: 'BUDGET' },
    ];
    fundType[0].disabled = true;
    unitSelector[0].disabled = true;
  }

  rekeningSelector[0].handleSearchContent = onSearchBankAccount;
  rekeningSelector[0].async = true;

  if (tipe === '2') {
    unitSelector[0].label = (!isDebit) ? 'Unit Sumber' : 'Unit Tujuan';
    unitSelector[0].handleSearchContent = onSearchUnit;
    unitSelector[0].async = true;
    unitSelector[0].disabled = isReconciliation && isDebit;

    destinationSelector[0].label = (!isDebit) ? 'Kode Akun Sumber' : 'Kode Akun Tujuan';
    destinationSelector[0].disabled = isReconciliation && isDebit;
    destinationSelector[0].handleSearchContent = onSearchDestinationAccount;
    destinationSelector[0].async = true;

    fields = filter(fields, field => field.name !== 'pos');
  } else {
    fields = filter(fields, o => o.name !== 'unit' && o.name !== 'destination_account');
  }


  return (
    <ListForm
      form={form}
      coa={coa}
      formFields={fields}
      onFormChange={onFormChange}
    />
  );
}


BankJournalFormHeader.propTypes = {
  form: PropTypes.object,
  coa: PropTypes.object,
  user: PropTypes.object.isRequired,
  onFormChange: PropTypes.func,
  isDebit: PropTypes.bool,
  onSearchUnit: PropTypes.func,
  onSearchBankAccount: PropTypes.func,
  onSearchDestinationAccount: PropTypes.func,
  isReconciliation: PropTypes.bool,
};

BankJournalFormHeader.defaultProps = {
  form: {},
  coa: {},
  onFormChange: noop,
  isDebit: false,
  onSearchUnit: noop,
  onSearchBankAccount: noop,
  onSearchDestinationAccount: noop,
  isReconciliation: false,
};
